<template >
  <div>
    <v-container fluid pa-0 my-4>
      <v-expansion-panels>
        <v-expansion-panel>
          <v-expansion-panel-header class="header-filtros" expand-icon="" @click="handleClick, controlOpenned(), passElement()"
            :class="{ 'bigHeader': this.activeBigHead }">
            <v-row no-gutters>
              <v-col cols="1" class="ma-3">
                <v-icon v-if="!open" left>
                  mdi-filter-variant-plus
                </v-icon>
                <v-icon v-else left>
                  mdi-filter-variant-minus
                </v-icon>
                Filtrar
              </v-col>
              <v-col>
                <v-fade-transition leave-absolute>
                  <span v-if="open === false" class="chip-margem">

                    <!-- Colocar o valor dos Filtros aqui -->
                    <span v-for="(item, index) in itemLabelFilter" :key="index">
                      <v-chip class="ma-2" outlined v-if="item.label && item.value">
                        <span v-html="`<b> ${item.label} </b>&nbsp;${item.value}`"></span>
                      </v-chip>
                    </span>
                  </span>
                </v-fade-transition>
              </v-col>
            </v-row>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-divider class="border-opacity-50" />
            <div class="d-flex justify-start">
              <slot />
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-container>
  </div>
</template>
<script>
import _ from 'lodash'
export default {
  name: 'expansionPanelDefault',
  props: {
    ativarLabelFilter: {
      type: Boolean,
      default: () => { false }
    },
    handleClick: {
      type: Function,
      default: () => { false }
    }
  },
  data: () => ({
    open: false,
    itemLabelFilter: '',
    countItemFilter: 0,
    activeBigHead: false
  }),
  mounted() {
  },
  created() {
  },
  computed: {
  },
  methods: {
    controlOpenned() {
      this.open = !this.open
      this.countValidFilter()
    },
    passElement() {
      this.itemLabelFilter = this.handleClick()
    },

    countValidFilter() {
      if (this.itemLabelFilter) {
        this.countItemFilter = 0
        let i = 0
        _.forEach(this.itemLabelFilter, () => {
          if (this.itemLabelFilter[i].value) {
            this.countItemFilter++
          }
          i++
        })
        if (this.countItemFilter > 8) {
          this.activeBigHead = true;
        } else {
          this.activeBigHead = false;
        }
      }
    }
  },
}
</script>
<style lang="scss" scoped>
@import '../../../assets/styles/components/expanse-panel';
</style>